export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-comment-video-18135d20292394ce5f176dba81cd8055.svg";